module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"safe-zone":"Ambiente Seguro","theme":{"mundipagg":"Mundipagg","jpmorgan":"Powered by Mundipagg","pagarme":"Pagar.me"}},"en-US":{"safe-zone":"Secure Environment","theme":{"mundipagg":"Mundipagg","jpmorgan":"Powered by Mundipagg","pagarme":"Pagar.me"}}}')
  delete Component.options._Ctor
}
